import React, { FC } from 'react';

import styles from './eventHeaderStyles.scss';

const EventHeader: FC = () => (
  <header className={styles.headerContainer}>
    <div className={styles.headerContent}>
      <div className={styles.headerLogo}>
        <img src="/images/event/AS-LOGO-RGB-REV.png" alt="AlphaSense" />
        x
        <img src="/images/logo_darkbg_350.png" alt="SumZero" />
      </div>
      <h1 className={styles.headerTitle}>BUYSIDE IDEA DINNER</h1>
      <div className={styles.headerTagline}>NYC Edition</div>
    </div>
  </header>
);

export default EventHeader;
